import '../../scss/password.scss'
